import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../../../common/theme/ISpcTheme';

export type SpecificationsAndFeaturesClasses =
  | 'viewSpecificationsFeaturesLink'
  | 'brochureLink'
  | 'linksContainer'
  | 'brochureLinkWrapper';

const specificationsAndFeaturesStyles = makeStyles<ISpcTheme, SpecificationsAndFeaturesClasses>(
  theme => ({
    linksContainer: {
      paddingBottom: '20px',
    },
    viewSpecificationsFeaturesLink: {
      color: theme.palette.secondary.main,
      textDecoration: 'underline',
    },
    brochureLink: {
      color: theme.palette.secondary.main,
      textDecoration: 'underline',
      paddingLeft: '30px',
    },
    brochureLinkWrapper: {
      textAlign: 'right',
    },
  }),
  { name: 'Customise_SpecificationsAndFeatures' },
);

export default specificationsAndFeaturesStyles;
